import React from "react";
import referral from "../../../../../image/referral/referral.png";
import cashInHand from "../../../../../image/referral/cash-in-hand.png";
import friend from "../../../../../image/referral/friend.png";

import { Container } from "react-bootstrap";

import { ROUTE_REFERRAL_DETAIL } from "../../../../../routes";

import {
  ContainerCode,
  ContainerHistoryReferral,
  ContainerInfoHistoryReferral,
  ContainerMainInfoReferral,
  HeaderHistoryReferral,
  ImageReferral,
  LinkDetailReferral,
} from "./styledUserReferralComponent";

function UserReferralComponent({ info, referralCode }) {
  const cardContant = [
    {
      id: 1,
      image: friend,
      alt: "friend",
      content: "تعداد افرادی که تاکنون دعوت کرده اید.",
      details: `${info?.invited_count} نفر`,
    },
    {
      id: 2,
      image: cashInHand,
      alt: "cash-in-hand",
      content: "درآمدی که از دعوت دوستان کسب کرده اید.",
      details: `${(
        info?.total_deposit + info?.total_withdraw
      )?.toLocaleString()} تومان`,
      linkDetail: (
        <LinkDetailReferral to={ROUTE_REFERRAL_DETAIL}>
          جزیات بیشتر
        </LinkDetailReferral>
      ),
    },
  ];
  return (
    <Container>
      <ContainerMainInfoReferral className="p-3">
        <div className="referral-title text-center">
          <strong>کد معرف = کد</strong>
          <strong>تخفیف</strong>
        </div>
        <ImageReferral src={referral} className="d-block mx-auto img-fluid" />
        <p className="referral-detail text-center mb-4 mb-md-2">
          با معرفی آزتو به دوستان و آشناهاتون، هم آن ها موقع خرید تخفیف می گیرند و هم
          شما درآمد کسب می کنید.
        </p>
        <p className="referral-detail text-center mb-3 mb-md-4">
          فقط کافیه آن ها موقع خرید کد معرف شما رو به عنوان کد تخفیف وارد کنند.
        </p>
        <ContainerCode className="d-flex align-items-center">
          کد معرف شما: {referralCode}
        </ContainerCode>
      </ContainerMainInfoReferral>
      <ContainerHistoryReferral className="p-3">
        <HeaderHistoryReferral>تاریخچه دعوت از دوستان</HeaderHistoryReferral>
        <div className="d-flex flex-column flex-md-row justify-content-center">
          {cardContant.map((item) => (
            <ContainerInfoHistoryReferral key={item.id}>
              <img src={item.image} alt={item.alt} />
              <p className="card-content text-center">{item.content}</p>
              <p className="card-details text-center">{item.details}</p>
              {item.linkDetail}
            </ContainerInfoHistoryReferral>
          ))}
        </div>
        <p className="caption text-center mx-auto mt-3 mt-md-4">
          هنگامی که میزان درآمد شما به حداقل 100,000 تومان رسید، می توانید با
          پشتیبانی تماس گرفته و با اعلام شماره کارت درآمد خود را به حساب بانکی تان
          واریز نمائید.
        </p>
      </ContainerHistoryReferral>
    </Container>
  );
}

export default UserReferralComponent;
